import {
  AssignmentBadRequestError,
  AssignmentDoesNotExistError,
  UserNotPermittedError
} from "@seneca/assignments-service-client";

import { UnsupportedSpecTypeError } from "seneca-common/features/assignments/state";
import { UpdateReason } from "seneca-common/features/update-app-modal/reasons";
import { showUpdateAppModal } from "seneca-common/features/update-app-modal/redux-navigation-workaround/state";
import { ErrorHandler, throttledLogError } from "seneca-common/utils/apiStates";

import errorTranslator from "./errorTranslator";

const assignmentServiceErrorHandler: ErrorHandler = (
  error,
  { errorAction },
  dispatch
) => {
  errorAction(errorTranslator(error));

  if (error instanceof UnsupportedSpecTypeError) {
    dispatch(showUpdateAppModal(UpdateReason.ASSIGNMENTS));
  }

  if (
    !(
      error instanceof UserNotPermittedError ||
      error instanceof AssignmentDoesNotExistError ||
      error instanceof AssignmentBadRequestError
    )
  ) {
    throttledLogError(error);
  }
};

export default assignmentServiceErrorHandler;
